//图标选择器配置
export default {
  icons: [
    {
      name: "默认",
      icons: [
        "el-icon-add-location",
        "el-icon-aim",
        "el-icon-alarm-clock",
        "el-icon-apple",
        "el-icon-arrow-down",
        "el-icon-arrow-down-bold",
        "el-icon-arrow-left",
        "el-icon-arrow-left-bold",
        "el-icon-arrow-right",
        "el-icon-arrow-right-bold",
        "el-icon-arrow-up",
        "el-icon-arrow-up-bold",
        "el-icon-avatar",
        "el-icon-back",
        "el-icon-baseball",
        "el-icon-basketball",
        "el-icon-bell",
        "el-icon-bell-filled",
        "el-icon-bicycle",
        "el-icon-bottom",
        "el-icon-bottom-left",
        "el-icon-bottom-right",
        "el-icon-bowl",
        "el-icon-box",
        "el-icon-briefcase",
        "el-icon-brush",
        "el-icon-brush-filled",
        "el-icon-burger",
        "el-icon-calendar",
        "el-icon-camera",
        "el-icon-camera-filled",
        "el-icon-caret-bottom",
        "el-icon-caret-left",
        "el-icon-caret-right",
        "el-icon-caret-top",
        "el-icon-cellphone",
        "el-icon-chat-dot-round",
        "el-icon-chat-dot-square",
        "el-icon-chat-line-round",
        "el-icon-chat-line-square",
        "el-icon-chat-round",
        "el-icon-chat-square",
        "el-icon-check",
        "el-icon-checked",
        "el-icon-cherry",
        "el-icon-chicken",
        "el-icon-circle-check",
        "el-icon-circle-check-filled",
        "el-icon-circle-close",
        "el-icon-circle-close-filled",
        "el-icon-circle-plus",
        "el-icon-circle-plus-filled",
        "el-icon-clock",
        "el-icon-close",
        "el-icon-close-bold",
        "el-icon-cloudy",
        "el-icon-coffee",
        "el-icon-coffee-cup",
        "el-icon-coin",
        "el-icon-cold-drink",
        "el-icon-collection",
        "el-icon-collection-tag",
        "el-icon-comment",
        "el-icon-compass",
        "el-icon-connection",
        "el-icon-coordinate",
        "el-icon-copy-document",
        "el-icon-cpu",
        "el-icon-credit-card",
        "el-icon-crop",
        "el-icon-d-arrow-left",
        "el-icon-d-arrow-right",
        "el-icon-d-caret",
        "el-icon-data-analysis",
        "el-icon-data-board",
        "el-icon-data-line",
        "el-icon-delete",
        "el-icon-delete-filled",
        "el-icon-delete-location",
        "el-icon-dessert",
        "el-icon-discount",
        "el-icon-dish",
        "el-icon-dish-dot",
        "el-icon-document",
        "el-icon-document-add",
        "el-icon-document-checked",
        "el-icon-document-copy",
        "el-icon-document-delete",
        "el-icon-document-remove",
        "el-icon-download",
        "el-icon-drizzling",
        "el-icon-edit",
        "el-icon-edit-pen",
        "el-icon-eleme",
        "el-icon-eleme-filled",
        "el-icon-element-plus",
        "el-icon-expand",
        "el-icon-failed",
        "el-icon-female",
        "el-icon-files",
        "el-icon-film",
        "el-icon-filter",
        "el-icon-finished",
        "el-icon-first-aid-kit",
        "el-icon-flag",
        "el-icon-fold",
        "el-icon-folder",
        "el-icon-folder-add",
        "el-icon-folder-checked",
        "el-icon-folder-delete",
        "el-icon-folder-opened",
        "el-icon-folder-remove",
        "el-icon-food",
        "el-icon-football",
        "el-icon-fork-spoon",
        "el-icon-fries",
        "el-icon-full-screen",
        "el-icon-goblet",
        "el-icon-goblet-full",
        "el-icon-goblet-square",
        "el-icon-goblet-square-full",
        "el-icon-goods",
        "el-icon-goods-filled",
        "el-icon-grape",
        "el-icon-grid",
        "el-icon-guide",
        "el-icon-headset",
        "el-icon-help",
        "el-icon-help-filled",
        "el-icon-hide",
        "el-icon-histogram",
        "el-icon-home-filled",
        "el-icon-hot-water",
        "el-icon-house",
        "el-icon-ice-cream",
        "el-icon-ice-cream-round",
        "el-icon-ice-cream-square",
        "el-icon-ice-drink",
        "el-icon-ice-tea",
        "el-icon-info-filled",
        "el-icon-iphone",
        "el-icon-key",
        "el-icon-knife-fork",
        "el-icon-lightning",
        "el-icon-link",
        "el-icon-list",
        "el-icon-loading",
        "el-icon-location",
        "el-icon-location-filled",
        "el-icon-location-information",
        "el-icon-lock",
        "el-icon-lollipop",
        "el-icon-magic-stick",
        "el-icon-magnet",
        "el-icon-male",
        "el-icon-management",
        "el-icon-map-location",
        "el-icon-medal",
        "el-icon-menu",
        "el-icon-message",
        "el-icon-message-box",
        "el-icon-mic",
        "el-icon-microphone",
        "el-icon-milk-tea",
        "el-icon-minus",
        "el-icon-money",
        "el-icon-monitor",
        "el-icon-moon",
        "el-icon-moon-night",
        "el-icon-more",
        "el-icon-more-filled",
        "el-icon-mostly-cloudy",
        "el-icon-mouse",
        "el-icon-mug",
        "el-icon-mute",
        "el-icon-mute-notification",
        "el-icon-no-smoking",
        "el-icon-notebook",
        "el-icon-notification",
        "el-icon-odometer",
        "el-icon-office-building",
        "el-icon-open",
        "el-icon-operation",
        "el-icon-opportunity",
        "el-icon-orange",
        "el-icon-paperclip",
        "el-icon-partly-cloudy",
        "el-icon-pear",
        "el-icon-phone",
        "el-icon-phone-filled",
        "el-icon-picture",
        "el-icon-picture-filled",
        "el-icon-picture-rounded",
        "el-icon-pie-chart",
        "el-icon-place",
        "el-icon-platform",
        "el-icon-plus",
        "el-icon-pointer",
        "el-icon-position",
        "el-icon-postcard",
        "el-icon-pouring",
        "el-icon-present",
        "el-icon-price-tag",
        "el-icon-printer",
        "el-icon-promotion",
        "el-icon-question-filled",
        "el-icon-rank",
        "el-icon-reading",
        "el-icon-reading-lamp",
        "el-icon-refresh",
        "el-icon-refresh-left",
        "el-icon-refresh-right",
        "el-icon-refrigerator",
        "el-icon-remove",
        "el-icon-remove-filled",
        "el-icon-right",
        "el-icon-scale-to-original",
        "el-icon-school",
        "el-icon-scissor",
        "el-icon-search",
        "el-icon-select",
        "el-icon-sell",
        "el-icon-semi-select",
        "el-icon-service",
        "el-icon-set-up",
        "el-icon-setting",
        "el-icon-share",
        "el-icon-ship",
        "el-icon-shop",
        "el-icon-shopping-bag",
        "el-icon-shopping-cart",
        "el-icon-shopping-cart-full",
        "el-icon-smoking",
        "el-icon-soccer",
        "el-icon-sold-out",
        "el-icon-sort",
        "el-icon-sort-down",
        "el-icon-sort-up",
        "el-icon-stamp",
        "el-icon-star",
        "el-icon-star-filled",
        "el-icon-stopwatch",
        "el-icon-success-filled",
        "el-icon-sugar",
        "el-icon-suitcase",
        "el-icon-sunny",
        "el-icon-sunrise",
        "el-icon-sunset",
        "el-icon-switch",
        "el-icon-switch-button",
        "el-icon-takeaway-box",
        "el-icon-ticket",
        "el-icon-tickets",
        "el-icon-timer",
        "el-icon-toilet-paper",
        "el-icon-tools",
        "el-icon-top",
        "el-icon-top-left",
        "el-icon-top-right",
        "el-icon-trend-charts",
        "el-icon-trophy",
        "el-icon-turn-off",
        "el-icon-umbrella",
        "el-icon-unlock",
        "el-icon-upload",
        "el-icon-upload-filled",
        "el-icon-user",
        "el-icon-user-filled",
        "el-icon-van",
        "el-icon-video-camera",
        "el-icon-video-camera-filled",
        "el-icon-video-pause",
        "el-icon-video-play",
        "el-icon-view",
        "el-icon-wallet",
        "el-icon-wallet-filled",
        "el-icon-warning",
        "el-icon-warning-filled",
        "el-icon-watch",
        "el-icon-watermelon",
        "el-icon-wind-power",
        "el-icon-zoom-in",
        "el-icon-zoom-out"
      ]
    },
    {
      name: "扩展",
      icons: [
        "sc-icon-vue",
        "sc-icon-code",
        "sc-icon-wechat",
        "sc-icon-bug-fill",
        "sc-icon-bug-line",
        "sc-icon-file-word",
        "sc-icon-file-excel",
        "sc-icon-file-ppt",
        "sc-icon-organization",
        "sc-icon-upload",
        "sc-icon-download",
        "sc-icon-store",
        "sc-icon-goods"
      ]
    }
  ]
}
